import axios from "axios";

export const getBackendBaseURL = () => {
  if (process.env.NODE_ENV === "production") {
    return "https://api.convertdm.com/";
  } else {
    return "http://localhost:3001/";
  }
};

export const getAdminFrontendURL = () => {
  if (process.env.NODE_ENV === "production") {
    return "https://app.convertdm.com";
  } else {
    return "http://localhost:3002";
  }
};

export const getLoginURL = () => {
  if (process.env.NODE_ENV === "production") {
    return "https://app.convertdm.com";
  } else {
    return "http://localhost:5001";
  }
};

export default axios.create({
  baseURL: getBackendBaseURL(),
});
